var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NetworkType } from '..';
import { BlockExplorer } from './block-explorer';
export class TezblockBlockExplorer extends BlockExplorer {
    constructor(rpcUrls = {
        [NetworkType.MAINNET]: 'https://tezblock.io',
        [NetworkType.DELPHINET]: 'https://delphinet.tezblock.io',
        [NetworkType.EDONET]: 'https://edonet.tezblock.io',
        [NetworkType.FLORENCENET]: 'https://florencenet.tezblock.io',
        [NetworkType.GRANADANET]: 'https://granadanet.tezblock.io',
        [NetworkType.CUSTOM]: 'https://granadanet.tezblock.io'
    }) {
        super(rpcUrls);
        this.rpcUrls = rpcUrls;
    }
    getAddressLink(address, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockExplorer = yield this.getLinkForNetwork(network);
            return `${blockExplorer}/account/${address}`;
        });
    }
    getTransactionLink(transactionId, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockExplorer = yield this.getLinkForNetwork(network);
            return `${blockExplorer}/transaction/${transactionId}`;
        });
    }
}
//# sourceMappingURL=tezblock-blockexplorer.js.map